import React from "react";
import "./FishHoqoqi.scss";
// import utilsFunction from "../../../utils/utilsFunction";
import logo from "../../../Assets/Images/لوگو ورکان 2 1.png";
import NumericFunction from "../../../utils/NumericFunction";
import commaSeparator, {
  formatToPersianAddComma,
} from "../../../utils/CommaSeparator";
import Num2persian from "num2persian";

const FishHoqoqi = (props) => {
  const jamKosouratQanooni = formatToPersianAddComma(
    Number(props.data.workerInsurance) +
      Number(props.data.workerTax) +
      Number(props.data.workerVam) +
      Number(props.data.workerKosurat) +
      Number(props.data.helpful)
  );

  const jamKosouratEkhtiari = formatToPersianAddComma(
    Number(props.data.lifeInsurance) + Number(props.data.workerInsuranceCEO)
  );

  const JamHoqoqOmazaya = formatToPersianAddComma(
    Number(props.data.jobReward) +
      Number(props.data.workerBen) +
      Number(props.data.workerHousing) +
      Number(props.data.workerPost) +
      Number(props.data.workerChild) +
      Number(props.data.workerChild) +
      Number(props.data.workerMission) +
      Number(props.data.overTime) +
      Number(props.data.otherRewards)
  );

  const NumberJamHOqoqMazaya =
    Number(props.data.jobReward) +
    Number(props.data.workerBen) +
    Number(props.data.workerHousing) +
    Number(props.data.workerPost) +
    Number(props.data.workerChild) +
    Number(props.data.workerChild) +
    Number(props.data.workerMission) +
    Number(props.data.overTime) +
    Number(props.data.otherRewards);

  const NumEkhtiari =
    Number(props.data.lifeInsurance) + Number(props.data.workerInsuranceCEO);
  const NumQanooni =
    Number(props.data.workerInsurance) +
    Number(props.data.workerTax) +
    Number(props.data.workerVam) +
    Number(props.data.workerKosurat) +
    Number(props.data.helpful);

  // const mablaqKhales = Number(JamHoqoqOmazaya - (jamKosouratQanooni +jamKosouratEkhtiari));
  const mablaqKhales = NumberJamHOqoqMazaya - (NumQanooni + NumEkhtiari);

  return (
    <div className="fish__wrap">
      <div className="fish__head">
        <div className="heade_right">
          <div className="img__">
            <img src={logo} alt="لوگو ورکان" />
          </div>
          <span>
            شرکت برنامه سازان
            <br />
            ورکـان خـاورمیـانـه
          </span>
        </div>
        <h1>{props.data.title}</h1>
        <div className="head_left">
          <div className="date__">
            <span>{NumericFunction.e2p(props.data.time)}</span> ,{" "}
            <span>{props.data.todayDate}</span>
          </div>
          <span className="name__">{props.data.name}</span>
        </div>
      </div>
      <div className="top_sec_fish">
        <div className="detail__box">
          <label>آقا/ خانم</label>
          <span>{props.data.name}</span>
        </div>

        <div className="detail__box">
          <label>تحصیلات</label>
          <span>{props.data.education}</span>
        </div>

        <div className="detail__box">
          <label>شغل</label>
          <span>{props.data.jobTitle}</span>
        </div>

        <div className="detail__box">
          <label>حقوق ماه</label>
          <span>{props.data.salary} ماه </span>
        </div>

        <div className="detail__box">
          <label>کارکرد</label>
          <span>{NumericFunction.e2p(props.data.daysOfWork)} روز</span>
        </div>

        <div className="detail__box">
          <label>شماره حساب/کارت</label>
          <span>{NumericFunction.e2p(props.data.accountNumber)}</span>
        </div>

        <div className="detail__box">
          <label>تاریخ درخواست</label>
          <span>{NumericFunction.e2p(props.data.requestDate)}</span>
        </div>

        <div className="detail__box">
          <label>تاریخ شروع به کار</label>
          <span>{NumericFunction.e2p(props.data.startWorkDate)}</span>
        </div>
      </div>

      <div className="wrap__content">
        <div className="second_sec_fish">
          <div className="title__">
            <svg
              width="15"
              height="17"
              viewBox="0 0 15 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 11.0981C-0.5 9.94338 -0.5 7.05662 1.5 5.90192L10.5 0.705772C12.5 -0.44893 15 0.994447 15 3.30385L15 13.6962C15 16.0056 12.5 17.4489 10.5 16.2942L1.5 11.0981Z"
                fill="#DADADA"
              />
            </svg>
            <label>حقوق و مزایا</label>
          </div>
          <div className="child_second_sec_fish">
            <div className="detail__box half_width">
              <label>مزد شغل :</label>
              <span>
                {NumericFunction.e2p(commaSeparator(props.data.jobReward))} ريال{" "}
              </span>
            </div>

            <div className="detail__box half_width">
              <label>بن کارگری :</label>
              <span>
                {NumericFunction.e2p(commaSeparator(props.data.workerBen))} ريال
              </span>
            </div>

            <div className="detail__box half_width">
              <label>حق مسکن :</label>
              <span>
                {NumericFunction.e2p(commaSeparator(props.data.workerHousing))}{" "}
                ريال
              </span>
            </div>

            <div className="detail__box half_width">
              <label>حق پست :</label>
              <span>
                {NumericFunction.e2p(commaSeparator(props.data.workerPost))}{" "}
                ريال
              </span>
            </div>

            <div className="detail__box half_width">
              <label>حق اولاد :</label>
              <span>
                {NumericFunction.e2p(commaSeparator(props.data.workerChild))}{" "}
                ريال
              </span>
            </div>

            <div className="detail__box half_width">
              <label>حق ماموریت :</label>
              <span>
                {NumericFunction.e2p(commaSeparator(props.data.workerMission))}{" "}
                ريال
              </span>
            </div>

            <div className="detail__box half_width">
              <label>اضافه کار :</label>
              <span>
                {NumericFunction.e2p(commaSeparator(props.data.overTime))} ريال
              </span>
            </div>

            <div className="detail__box half_width">
              <label>سنوات :</label>
              <span>
                {NumericFunction.e2p(commaSeparator(props.data.sanavat))} ريال
              </span>
            </div>

            <div className="detail__box half_width">
              <label>سایر پاداش ها :</label>
              <span>
                {NumericFunction.e2p(commaSeparator(props.data.otherRewards))}{" "}
                ريال
              </span>
            </div>
          </div>
        </div>

        <div className="second_sec_fish">
          <div className="title__">
            <svg
              width="15"
              height="17"
              viewBox="0 0 15 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 11.0981C-0.5 9.94338 -0.5 7.05662 1.5 5.90192L10.5 0.705772C12.5 -0.44893 15 0.994447 15 3.30385L15 13.6962C15 16.0056 12.5 17.4489 10.5 16.2942L1.5 11.0981Z"
                fill="#DADADA"
              />
            </svg>
            <label>کسورات قانونی</label>
          </div>
          <div className="child_second_sec_fish">
            <div className="detail__box half_width">
              <label> حق بیمه سهم کارگر :</label>
              <span>
                {NumericFunction.e2p(
                  commaSeparator(props.data.workerInsurance)
                )}{" "}
                ريال
              </span>
            </div>

            <div className="detail__box half_width">
              <label>مالیات :</label>
              <span>
                {NumericFunction.e2p(commaSeparator(props.data.workerTax))} ريال
              </span>
            </div>

            <div className="detail__box half_width">
              <label>قسط و وام :</label>
              <span>
                {NumericFunction.e2p(commaSeparator(props.data.workerVam))} ريال
              </span>
            </div>

            <div className="detail__box half_width">
              <label>سایر کسورات :</label>
              <span>
                {NumericFunction.e2p(commaSeparator(props.data.workerKosurat))}{" "}
                ريال
              </span>
            </div>

            <div className="detail__box half_width">
              <label>مساعده :</label>
              <span>
                {NumericFunction.e2p(commaSeparator(props.data.helpful))} ريال
              </span>
            </div>
          </div>
        </div>

        <div className="second_sec_fish">
          <div className="title__">
            <svg
              width="15"
              height="17"
              viewBox="0 0 15 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 11.0981C-0.5 9.94338 -0.5 7.05662 1.5 5.90192L10.5 0.705772C12.5 -0.44893 15 0.994447 15 3.30385L15 13.6962C15 16.0056 12.5 17.4489 10.5 16.2942L1.5 11.0981Z"
                fill="#DADADA"
              />
            </svg>
            <label>کسورات اختیاری</label>
          </div>
          <div className="child_second_sec_fish">
            <div className="detail__box half_width">
              <label> بیمه عمر و حوادث : </label>
              <span>
                {NumericFunction.e2p(commaSeparator(props.data.lifeInsurance))}{" "}
                ريال{" "}
              </span>
            </div>

            <div className="detail__box half_width">
              <label>بیمه مکمل درمان :</label>
              <span>
                {NumericFunction.e2p(
                  commaSeparator(props.data.workerOtherBime)
                )}{" "}
                ريال
              </span>
            </div>
          </div>
        </div>

        <div className="second_sec_fish">
          <div className="title__">
            <svg
              width="15"
              height="17"
              viewBox="0 0 15 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 11.0981C-0.5 9.94338 -0.5 7.05662 1.5 5.90192L10.5 0.705772C12.5 -0.44893 15 0.994447 15 3.30385L15 13.6962C15 16.0056 12.5 17.4489 10.5 16.2942L1.5 11.0981Z"
                fill="#DADADA"
              />
            </svg>
            <label>سهم کارفرما </label>
          </div>
          <div className="child_second_sec_fish">
            <div className="detail__box half_width">
              <label>سهم کارفرما :</label>
              <span>
                {NumericFunction.e2p(
                  commaSeparator(props.data.workerInsuranceCEO)
                )}{" "}
                ريال
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="footer__fish">
        <div className="footer_fish_item">
          <label>جمـع حقوق و مـزایا : </label>
          <span>{JamHoqoqOmazaya}ريال</span>
        </div>

        <div className="footer_fish_item">
          <label> جمـع کسورات قانونـی : </label>
          <span>{jamKosouratQanooni} ريال</span>
        </div>

        <div className="footer_fish_item">
          <label> جمع کسورات اختیاری :</label>
          <span>{jamKosouratEkhtiari} ريال</span>
        </div>

        <div className="footer_fish_item money__box">
          <div className="item__foot_">
            <label> مبلغ خالص دریافتی : </label>
            <span>{formatToPersianAddComma(mablaqKhales)}ريال </span>
          </div>

          <span>{Num2persian(mablaqKhales)} ریال </span>
        </div>
      </div>

      <div className="main__footer">
        <div className="right_side_foot">
          <svg
            width="12"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.7475 4.63335C11.0475 1.55335 8.36082 0.166687 6.00082 0.166687C6.00082 0.166687 6.00082 0.166687 5.99415 0.166687C3.6408 0.166687 0.947463 1.54669 0.247463 4.62669C-0.532537 8.06669 1.57413 10.98 3.4808 12.8134C4.18746 13.4934 5.09415 13.8334 6.00082 13.8334C6.90748 13.8334 7.81415 13.4934 8.51415 12.8134C10.4208 10.98 12.5275 8.07335 11.7475 4.63335ZM6.00082 7.97335C4.84082 7.97335 3.9008 7.03335 3.9008 5.87335C3.9008 4.71335 4.84082 3.77335 6.00082 3.77335C7.16082 3.77335 8.10082 4.71335 8.10082 5.87335C8.10082 7.03335 7.16082 7.97335 6.00082 7.97335Z"
              fill="#808487"
            />
          </svg>
          <span>
            گلستان، گرگان، میدان مفتح
            <br /> کـارخـانـه نـوآوری گـرگـان
          </span>
        </div>
        <div className="center_foot">
          <div className="text__">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.63341 9.96665L9.86675 11.2C10.1267 11.46 10.5401 11.46 10.8067 11.2066C10.8801 11.1333 10.9534 11.0666 11.0267 10.9933C11.7134 10.3 12.3334 9.57331 12.8867 8.81331C13.4334 8.05331 13.8734 7.29331 14.1934 6.53998C14.5067 5.77998 14.6667 5.05331 14.6667 4.35998C14.6667 3.90665 14.5867 3.47331 14.4267 3.07331C14.2667 2.66665 14.0134 2.29331 13.6601 1.95998C13.2334 1.53998 12.7667 1.33331 12.2734 1.33331C12.0867 1.33331 11.9001 1.37331 11.7334 1.45331C11.5601 1.53331 11.4067 1.65331 11.2867 1.82665L9.74008 4.00665C9.62008 4.17331 9.53341 4.32665 9.47341 4.47331C9.41341 4.61331 9.38008 4.75331 9.38008 4.87998C9.38008 5.03998 9.42675 5.19998 9.52008 5.35331C9.60675 5.50665 9.73341 5.66665 9.89341 5.82665L10.4001 6.35331C10.4734 6.42665 10.5067 6.51331 10.5067 6.61998C10.5067 6.67331 10.5001 6.71998 10.4867 6.77331C10.4667 6.82665 10.4467 6.86665 10.4334 6.90665C10.3134 7.12665 10.1067 7.41331 9.81341 7.75998C9.51341 8.10665 9.19341 8.45998 8.84675 8.81331C8.78008 8.87998 8.70675 8.94665 8.64008 9.01331C8.37341 9.27331 8.36675 9.69998 8.63341 9.96665Z"
                fill="#808487"
              />
              <path
                d="M1.35368 12.2194C1.35368 12.406 1.38702 12.5994 1.45368 12.786C1.47368 12.8394 1.49368 12.8927 1.52035 12.946C1.63368 13.186 1.78035 13.4127 1.97368 13.626C2.30035 13.986 2.66035 14.246 3.06702 14.4127C3.07368 14.4127 3.08035 14.4194 3.08702 14.4194C3.48035 14.5794 3.90701 14.666 4.36701 14.666C5.04702 14.666 5.77368 14.506 6.54035 14.1794C7.30702 13.8527 8.07368 13.4127 8.83368 12.8594C9.09368 12.666 9.35368 12.4727 9.60034 12.266L7.42035 10.086C7.23368 10.226 7.06702 10.3327 6.92702 10.406C6.89368 10.4194 6.85368 10.4394 6.80701 10.4594C6.75368 10.4794 6.70035 10.486 6.64035 10.486C6.52701 10.486 6.44035 10.446 6.36702 10.3727L5.86035 9.87271C5.69368 9.70604 5.53368 9.57938 5.38035 9.49938C5.22702 9.40604 5.07368 9.35938 4.90701 9.35938C4.78035 9.35938 4.64702 9.38604 4.50035 9.44604C4.35368 9.50604 4.20035 9.59271 4.03368 9.70604L1.82702 11.2727C1.65368 11.3927 1.53368 11.5327 1.46035 11.6994C1.39368 11.866 1.35368 12.0327 1.35368 12.2194Z"
                fill="#808487"
              />
            </svg>

            <span>017 321 30 334</span>
          </div>
          <div className="text__">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.8267 1.33331H5.17341C3.33341 1.33331 2.66675 1.99998 2.66675 3.87331V12.1266C2.66675 14 3.33341 14.6666 5.17341 14.6666H10.8201C12.6667 14.6666 13.3334 14 13.3334 12.1266V3.87331C13.3334 1.99998 12.6667 1.33331 10.8267 1.33331ZM8.00008 12.8666C7.36008 12.8666 6.83342 12.34 6.83342 11.7C6.83342 11.06 7.36008 10.5333 8.00008 10.5333C8.64008 10.5333 9.16675 11.06 9.16675 11.7C9.16675 12.34 8.64008 12.8666 8.00008 12.8666ZM9.33342 4.16665H6.66675C6.39341 4.16665 6.16675 3.93998 6.16675 3.66665C6.16675 3.39331 6.39341 3.16665 6.66675 3.16665H9.33342C9.60675 3.16665 9.83342 3.39331 9.83342 3.66665C9.83342 3.93998 9.60675 4.16665 9.33342 4.16665Z"
                fill="#808487"
              />
            </svg>
            <span>0911 768 8076</span>
          </div>
        </div>
        <div className="left_side_foot">
          <div className="text__">
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.3333 0.333313H3.66658C1.66659 0.333313 0.333252 1.33331 0.333252 3.66665V8.33331C0.333252 10.6666 1.66659 11.6666 3.66658 11.6666H10.3333C12.3333 11.6666 13.6666 10.6666 13.6666 8.33331V3.66665C13.6666 1.33331 12.3333 0.333313 10.3333 0.333313ZM10.6466 4.39331L8.55992 6.05998C8.11992 6.41331 7.55992 6.58665 6.99992 6.58665C6.43992 6.58665 5.87325 6.41331 5.43992 6.05998L3.35325 4.39331C3.13992 4.21998 3.10659 3.89998 3.27325 3.68665C3.44658 3.47331 3.75992 3.43331 3.97325 3.60665L6.05992 5.27331C6.56659 5.67998 7.42658 5.67998 7.93325 5.27331L10.0199 3.60665C10.2333 3.43331 10.5533 3.46665 10.7199 3.68665C10.8933 3.89998 10.8599 4.21998 10.6466 4.39331Z"
                fill="#808487"
              />
            </svg>
            <span className="website__">www.varkan.ir</span>
          </div>
          <div className="text__">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.09906 13.9399C5.07906 13.9399 5.0524 13.9532 5.0324 13.9532C3.73906 13.3132 2.68573 12.2532 2.03906 10.9599C2.03906 10.9399 2.0524 10.9132 2.0524 10.8932C2.86573 11.1332 3.70573 11.3132 4.53906 11.4532C4.68573 12.2932 4.85906 13.1265 5.09906 13.9399Z"
                fill="#808487"
              />
              <path
                d="M13.9594 10.9665C13.2994 12.2932 12.1994 13.3665 10.8594 14.0132C11.1127 13.1665 11.326 12.3132 11.466 11.4532C12.306 11.3132 13.1327 11.1332 13.946 10.8932C13.9394 10.9199 13.9594 10.9465 13.9594 10.9665Z"
                fill="#808487"
              />
              <path
                d="M14.0127 5.14033C13.1727 4.887 12.326 4.68033 11.466 4.53367C11.326 3.67367 11.1194 2.82033 10.8594 1.987C12.2394 2.647 13.3527 3.76033 14.0127 5.14033Z"
                fill="#808487"
              />
              <path
                d="M5.10039 2.05906C4.86039 2.8724 4.68706 3.69906 4.54706 4.53906C3.68706 4.6724 2.83373 4.88573 1.98706 5.13906C2.63373 3.79906 3.70706 2.69906 5.03373 2.03906C5.05373 2.03906 5.08039 2.05906 5.10039 2.05906Z"
                fill="#808487"
              />
              <path
                d="M10.3279 4.39331C8.78121 4.21998 7.22121 4.21998 5.67456 4.39331C5.84123 3.47998 6.05456 2.56665 6.35456 1.68665C6.36789 1.63331 6.36123 1.59331 6.36789 1.53998C6.89455 1.41331 7.43455 1.33331 8.00121 1.33331C8.56121 1.33331 9.10788 1.41331 9.62788 1.53998C9.63455 1.59331 9.63455 1.63331 9.64788 1.68665C9.94788 2.57331 10.1612 3.47998 10.3279 4.39331Z"
                fill="#808487"
              />
              <path
                d="M4.39325 10.3278C3.47325 10.1612 2.56659 9.94782 1.68659 9.64782C1.63325 9.63449 1.59325 9.64115 1.53992 9.63449C1.41325 9.10782 1.33325 8.56782 1.33325 8.00115C1.33325 7.44115 1.41325 6.89449 1.53992 6.3745C1.59325 6.36783 1.63325 6.36783 1.68659 6.3545C2.57325 6.06117 3.47325 5.84117 4.39325 5.6745C4.22659 7.22115 4.22659 8.78115 4.39325 10.3278Z"
                fill="#808487"
              />
              <path
                d="M14.6667 8.00115C14.6667 8.56782 14.5867 9.10782 14.46 9.63449C14.4067 9.64115 14.3667 9.63449 14.3134 9.64782C13.4267 9.94115 12.52 10.1612 11.6067 10.3278C11.78 8.78115 11.78 7.22115 11.6067 5.6745C12.52 5.84117 13.4334 6.0545 14.3134 6.3545C14.3667 6.36783 14.4067 6.3745 14.46 6.3745C14.5867 6.90115 14.6667 7.44115 14.6667 8.00115Z"
                fill="#808487"
              />
              <path
                d="M10.3279 11.6068C10.1612 12.5268 9.94788 13.4335 9.64788 14.3135C9.63455 14.3668 9.63455 14.4068 9.62788 14.4601C9.10788 14.5868 8.56121 14.6668 8.00121 14.6668C7.43455 14.6668 6.89455 14.5868 6.36789 14.4601C6.36123 14.4068 6.36789 14.3668 6.35456 14.3135C6.06123 13.4268 5.84123 12.5268 5.67456 11.6068C6.44789 11.6935 7.22121 11.7535 8.00121 11.7535C8.78121 11.7535 9.56121 11.6935 10.3279 11.6068Z"
                fill="#808487"
              />
              <path
                d="M10.5088 10.5088C8.84139 10.7192 7.15845 10.7192 5.49103 10.5088C5.28066 8.84145 5.28066 7.15851 5.49103 5.49109C7.15845 5.28072 8.84139 5.28072 10.5088 5.49109C10.7192 7.15851 10.7192 8.84145 10.5088 10.5088Z"
                fill="#808487"
              />
            </svg>
            <span>varkanpro@gmail.com</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FishHoqoqi;
